// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__6j","cls2":"AuthorHeader-cls2_Z_7 AuthorHeader-cls1__6j"};